const routes = [
    {
        path: '',
        component: () => import('@/shared/components/layout/Interno'),
        children: [
            {
                path: '/area_cliente/pedidos',
                component: () => import('../views/Listar')
            }
        ]
    },
    // GCK-20831: o detalhe do pedido usa o shell próprio do portal (PortalLayout)
    {
        path: '/area_cliente/pedidos/visualizar/:id',
        component: () => import('../views/Visualizar')
    }
]

export default routes
